import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { apiMiddleware } from '../../global/middleware/api-middleware';
import { ErrorBoundaryApp } from '../../global/components/error-boundary';
import { tcsmEpiApiReducerWithDefault } from '../../global/ducks/epi-api';
import { DefaultTcsmEpiApiState } from '../../root/tcsm-model';
import { AlertContainer } from './alert-container';
import { BrowserRouter } from 'react-router-dom';


export const stateReducer = combineReducers<any>({
	epiProps: tcsmEpiApiReducerWithDefault(DefaultTcsmEpiApiState),
});


const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const stateStore = createStore(stateReducer, composeEnhancers(
	applyMiddleware(
		apiMiddleware,
	),
));

const mount = document.getElementById('site-wide-alert');
const appSettings = (window as any).bootstrap;

if (mount) {

	ReactDOM.render(
		<Provider store={stateStore}>
			<BrowserRouter>
				<ErrorBoundaryApp>
					<AlertContainer siteSettingsId={appSettings?.siteSettingsId} currentCulture={appSettings?.currentCulture} />
				</ErrorBoundaryApp>
			</BrowserRouter>

		</Provider>, mount,
	);
}